import { GetStoryVersionOptionsMeta, GetStoryVersionOptionsPayload } from 'types/store/GetStoryVersionOptions';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryVersionOptionsActions } from '../actions';

export default createAsyncReducer<GetStoryVersionOptionsMeta, GetStoryVersionOptionsPayload>(getStoryVersionOptionsActions);
